var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from "react";
import { downloadReportJobFile, fetchReportJob, } from "../api/reportJobsService";
import { isReportJobActive, } from "../types/reports/reportJob";
import { JOB_POLL_INTERVAL_MS, usePolledJob } from "./usePolledJob";
/** Delay between two status polls (after the previous answer arrived). */
export var REPORT_JOB_POLL_INTERVAL_MS = JOB_POLL_INTERVAL_MS;
var STORAGE_KEY_PREFIX = "br-agency.report-job.";
/**
 * sessionStorage key holding the last job id of one report type.
 *
 * @param reportType report key (e.g. `identifier-report`)
 * @returns the storage key
 */
export var reportJobStorageKey = function (reportType) {
    return "".concat(STORAGE_KEY_PREFIX).concat(reportType);
};
var isActiveJob = function (job) { return isReportJobActive(job.status); };
/**
 * Tracks one asynchronously generated report (DB-876): polls
 * `GET /reports/jobs/{jobId}` every 2 s via {@link usePolledJob}, remembers the
 * job per report type in sessionStorage and downloads the finished file from
 * `GET /reports/jobs/{jobId}/file`.
 *
 * @param reportType report key the job belongs to
 */
export var useReportJob = function (reportType) {
    var polled = usePolledJob({
        storageKey: reportJobStorageKey(reportType),
        fetchStatus: fetchReportJob,
        isActive: isActiveJob,
    });
    var ky = polled.ky, jobId = polled.jobId, job = polled.state, startPolling = polled.start;
    var start = useCallback(function (started) {
        return startPolling(started.jobId, {
            jobId: started.jobId,
            status: started.status,
        });
    }, [startPolling]);
    var download = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!jobId)
                        return [2 /*return*/];
                    return [4 /*yield*/, downloadReportJobFile(ky, jobId, job === null || job === void 0 ? void 0 : job.fileName)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [ky, jobId, job === null || job === void 0 ? void 0 : job.fileName]);
    var status = job === null || job === void 0 ? void 0 : job.status;
    return {
        jobId: jobId,
        job: job,
        isGenerating: polled.isRunning,
        isDone: status === "DONE",
        isFailed: status === "FAILED",
        pollFailed: polled.pollFailed,
        retry: polled.retry,
        start: start,
        reset: polled.reset,
        download: download,
    };
};
